import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnChanges, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { IssueItem } from '@models/Sessions/Idea/podcast-api';
import { ShortDomainPipe } from '@pipes/short-domain.pipe';
import { PaginatorModule } from 'primeng/paginator';

import { IdeaEvidence } from '../../../../models/Sessions/Idea/evidence';

@Component({
  selector: 'app-missing-facts-list',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PaginatorModule,
    ShortDomainPipe,
  ],
  templateUrl: './missing-facts-list.component.html',
  styleUrl: './missing-facts-list.component.scss',
})
export class MissingFactsListComponent implements OnChanges, OnInit {
  @Input() facts: IssueItem[];
  @Input() evidence: IdeaEvidence[];
  @Input() pageSize = 3;
  @Input() pageLinkSize = 3;
  @Input() isSelectable = true;

  evidenceMap = new Map<string, IdeaEvidence>();
  factsFormArray: FormArray<FormControl<boolean>>;
  factControlCitationMap = new Map<string, FormControl>();

  page: IssueItem[] = [];
  pageIndex = 0; // Current page start index

  get isAnySelected() {
    return this.factsFormArray.controls.some(c => c.value);
  }

  get selectedFacts() {
    return this.facts.filter((_, i) => this.factsFormArray.at(i).value);
  }

  ngOnChanges() {
    this.evidenceMap = new Map(
      (this.evidence || []).map(e => [`${e.citation}`, e]),
    );
    this.updateCurrentPageItems();
  }

  private formBuilder = inject(FormBuilder);

  ngOnInit(): void {
    if (this.facts) {
      this.createForm();
    }
  }

  // Handle page change event
  onPageChange(event: any) {
    this.pageIndex = event.first;
    this.updateCurrentPageItems();
  }

  // Update items for current page
  updateCurrentPageItems() {
    const startIndex = this.pageIndex;
    const endIndex = this.pageIndex + this.pageSize;
    this.page = this.facts.slice(startIndex, endIndex);
  }

  private createForm() {
    this.factsFormArray = this.formBuilder.array(
      this.facts.map(fact => {
        const control = this.formBuilder.control(false);
        this.factControlCitationMap.set(fact.instruction, control);
        return control;
      }),
    );
  }
}
